export const  PaymentSourceTypeEnum = Object.freeze ({

    
   CoursePurchase:0,
   ExpertService:1,
   Certificate:2,
   Other :99
})


export const PaymentSourceTypeLabels = {
  [PaymentSourceTypeEnum.CoursePurchase]: "Course Purchase",
  [PaymentSourceTypeEnum.ExpertService]: "Expert Service",
  [PaymentSourceTypeEnum.Certificate]: "Certificate",
  [PaymentSourceTypeEnum.Other]: "Other"
};

export const PaymentSourceTypeColors = {
  [PaymentSourceTypeEnum.CoursePurchase]: "blue",
  [PaymentSourceTypeEnum.ExpertService]: "purple",
  [PaymentSourceTypeEnum.Certificate]: "green",
  [PaymentSourceTypeEnum.Other]: "gray"
};